import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { routerActions } from 'connected-react-router';
import PageLayout from '../../../components/common/PageLayout';
import MobileAppSvg from '../../../styles/assets/bitstop-app-layout-2.png';
import AppleStoreSvg from '../../../styles/assets/bitstop-app-apple-store.svg';
import GoogleStoreSvg from '../../../styles/assets/bitstop-app-google-store.svg';
import AppleStoreQR from '../../../styles/assets/bitstop-app-apple-store-qr.png';
import GoogleStoreQR from '../../../styles/assets/bitstop-google-app-store-qr.png';
import BitstopHeaderSvg from '../../../styles/assets/Bitstop_Web_Background.svg';
import '../../../styles/BitstopAppLanding/BitstopAppLanding.css';
import { DownloadApp as translations } from '../../../middlewares/i18n';

class BitstopAppLanding extends PureComponent {
  
  render() {
    const { i18n } = this.props;
    const language = i18n.language?.current || 'en';
    const translationData = translations[language];

    return (
      <div id="bitstop-app-landing" className="container">
        <img src={BitstopHeaderSvg} alt="Web Background" className="bg" />
        <PageLayout>
          <header className="columns">
            <h2 className="title">{translationData.title}</h2>
            <div className="subtitle">{translationData.subtitle}</div>
            {language == 'en' && (<div className='subtitle'>{translationData.subtitleMore}</div>)}
          </header>
          <div className="feature-set columns">
            <div className="col">
              <img src={MobileAppSvg} alt="Mobile App Preview" />
            </div>
            <div className="col">
              <ul>
                {translationData.appFeaturesList.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="app-stores columns">
            <div className="col apple">
              <img src={AppleStoreSvg} className="store-icon" alt="Apple App Store" />
              <img src={AppleStoreQR} className="qr-code" alt="Apple App Store QR Redirect" />
            </div>
            <div className="col google">
              <img src={GoogleStoreSvg} className="store-icon" alt="Google Play Store" />
              <img src={GoogleStoreQR} className="qr-code" alt="Google Play Store QR Redirect" />
            </div>
          </div>
          <div className="send-hodl-new__support">
            <h6 className="send-hodl-new__support-subtitle--weight no-margin">
              {translationData.supportFooterTitle}
            </h6>
            <h6 className="send-hodl-new__support-subtitle no-margin">
              {translationData.supportFooterSubtitle}
            </h6>
            <ul>
              <li className="send-hodl-new__support-subtitle--weight">
                {translationData.supportFooterEmail}
              </li>
              <li className="send-hodl-new__support-subtitle--spacing">
                {translationData.supportFooterPhone}
              </li>
            </ul>
          </div>
        </PageLayout>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      router: bindActionCreators(routerActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BitstopAppLanding);
